import {Form as AntdForm} from "../../../__snowpack__/pkg/antd.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import {createContext, useMemo} from "../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import React from "../../../__snowpack__/pkg/react.js";
import FormItem from "./FormItem.js";
import FieldValidator from "./FieldValidator.js";
export const GnFormContext = createContext(null);
export default function GnForm(props) {
  const {form: _form, className, scrollContainer = document, compact, ...restProps} = props;
  const {formatMessage} = useIntl();
  const [form] = AntdForm.useForm(_form);
  const validateMessages = useMemo(() => ({
    required: () => formatMessage({id: "isRequired"})
  }), [formatMessage]);
  const scrollToFirstErrorConfig = useMemo(() => ({
    behavior: () => {
      setTimeout(() => {
        if (scrollContainer) {
          const firstErrorItem = scrollContainer.querySelector(".ant-form-item-has-error");
          firstErrorItem?.scrollIntoView({block: "center", behavior: "smooth"});
        }
      }, 20);
    }
  }), [scrollContainer]);
  const value = useMemo(() => ({form, formProps: props, compact}), [props, form]);
  return /* @__PURE__ */ React.createElement(GnFormContext.Provider, {
    value
  }, /* @__PURE__ */ React.createElement(AntdForm, {
    form,
    className: classNames({
      "gn-form": true,
      [String(className)]: !!className
    }),
    validateMessages,
    scrollToFirstError: scrollToFirstErrorConfig,
    ...restProps
  }));
}
GnForm.useForm = AntdForm.useForm;
GnForm.Provider = AntdForm.Provider;
GnForm.Item = FormItem;
GnForm.List = AntdForm.List;
GnForm.ErrorList = AntdForm.ErrorList;
GnForm.Validator = FieldValidator;
export const {useForm} = AntdForm;
export const {Item} = GnForm;
